const BASE = process.env.REACT_APP_BACKEND_URL || "";
const TTS_API_ENDPOINT = "/polly/synthesize";
// const TTS_API_ENDPOINT = "/gcloud/synthesize";



export async function tts(text: string, voiceLanguage: string): Promise<{ text: string; audioUrl: string }> {
  let audioUrl = ""
  try {
    const response = await fetch(`${BASE}${TTS_API_ENDPOINT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text,
        language: voiceLanguage,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Speech synthesis failed");
    }

    const audioBlob = await response.blob();
    audioUrl = URL.createObjectURL(audioBlob);
  } catch (err) {
    console.error(err);
  } finally {
    return { text, audioUrl };
  }
}
